import React, {Component} from 'react';
import './LogInComponent.less';
import {FormInput, Checkbox} from '@homeaway/react-form-components';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {apiPost} from '../../util/api.client';
import edapWrapper from '@homeaway/edap-wrapper';

class LogInComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            password: '',
            loggedIn: false,
            errorMsg: '',
            resetPassword: false,
            rememberMe: false,
            disableLogin: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.buttonClicked = this.buttonClicked.bind(this);
        this.editEmail = this.editEmail.bind(this);
    }

    componentDidMount() {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                actionlocation: this.props.actionLocation,
                eventaction: 'login.visible',
                eventcategory: 'lex',
                eventlabel: 'ums'
            }
        });
    }

    handleSubmit(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleCheck(event) {
        this.setState({[event.target.name]: event.target.checked});
    }

    handleError(error, errorTitle) {
        this.edapLoginError();
        this.props.handleError(error, errorTitle);
    }

    edapLoginError() {
        edapWrapper().push({
            name: 'login.failure',
            data: {loginsource: 'lex', logintype: 'ums', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
    }

    loginSuccess(json) {
        this.setState({loggedIn: true});
        edapWrapper().push({
            name: 'login.success',
            data: {loginsource: 'lex', logintype: 'ums', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.setAuthJson(json);
        this.props.onClose();
    }

    checkStatus(response) {
        switch (response.status) {
            case 200:
                response.json().then((json) => {
                    this.loginSuccess(json);
                });
                break;
            case 401:
                this.props.disableLoading();
                this.edapLoginError();
                this.setState({errorMsg: this.props.lingua.read('lex.password.error')});
                break;
            case 403: // this is the response we get when user is locked out of account
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('lex.password.reset.warning'), this.props.lingua.read('lex.warning.title'));
                this.setState({resetPassword: true, errorMsg: ''});
                break;
            case 423: // this is the response we get when blocked status of Deleted, Permanent Substandard, Spammer, Substandard, Suspicious, Fraud
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.authentication.user.blocked'), this.props.lingua.read('lex.warning.title'));
                this.setState({resetPassword: false, errorMsg: '', disableLogin: true});
                break;
            default:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.generic'), '');
                break;
        }
    }

    editEmail(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.updatePage('initial');
    }

    buttonClicked() {
        this.props.enableLoading();
        if (this.state.resetPassword === true) {
            setTimeout(() => {
                this.resetPassword();
            }, 800);
        } else {
            setTimeout(() => {
                this.submitForm();
            }, 800);
        }
    }

    submitForm() {
        edapWrapper().push({
            name: 'login.attempt',
            data: {loginsource: 'lex', logintype: 'ums', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        apiPost('/auth/aam/v3/authenticate', {
            userName: this.state.emailAddress,
            secret: this.state.password,
            authType: 'HOMEAWAY',
            rememberMe: this.state.rememberMe
        }).then(this.checkStatus);
    }

    resetPassword() {
        const url = '/auth/aam/v3/password/reset';
        const body = {
            'emailAddress': this.state.emailAddress,
            serviceUrl: this.props.service
        };

        apiPost(url, body).then((response) => {
            if (response.status === 204) {
                this.props.updatePage('passwordreset');
            } else {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
            }
            this.props.disableLoading();
        });
    }

    getPasswordClasses() {
        return `form-group floating-label ${this.state.password === '' ? '' : 'not-empty'} has-feedback ${this.state.errorMsg === '' ? '' : 'has-error'}`;
    }

    getPasswordContent() {
        let passwordFieldClasses = this.getPasswordClasses();
        let disableLoginButton = !this.state.password || this.state.disableLogin;

        return (<div className="PasswordField">
            <div className={passwordFieldClasses}>
                <label>{this.props.lingua.read('lex.password.prompt')}</label>
                <input type={this.props.passwordType} className="form-control" aria-label={this.props.lingua.read('lex.password.prompt')}
                    name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "on"
                    disabled={this.state.disableLogin} autoFocus
                />
                <span className="PasswordShow" onClick={this.props.showHidePassword}>
                    {this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                </span>
                <span className={this.state.errorMsg === '' ? '' : 'help-block'}>{this.state.errorMsg}</span>
            </div>
            <div className="RememberMe">
                <Checkbox
                    name="rememberMe"
                    label={this.props.lingua.read('lex.login.remember')}
                    checked={this.state.rememberMe}
                    onChange={this.handleCheck}
                    size={'sm'}
                    inline
                />
            </div>
            <ButtonPrimary type="submit" label={this.props.lingua.read('account.signin.link.text')} onClick={this.buttonClicked} disabled={disableLoginButton} className="btn-lg">
                <LoadingOverlay loading={this.props.isWaiting}/>
            </ButtonPrimary>
        </div>);
    }

    getResetPasswordContent() {
        let passwordFieldClasses = this.getPasswordClasses();
        return (<div className="PasswordField">
            <div className={passwordFieldClasses}>
                <label>{this.props.lingua.read('lex.password.prompt')}</label>
                <input type={this.props.passwordType} className="form-control" aria-label={this.props.lingua.read('lex.password.prompt')}
                    name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "on" disabled autoFocus
                />
                <span className="PasswordDisabled" onClick={this.props.showHidePassword}>
                    {this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                </span>
            </div>
            <div className="RememberMe">
                <Checkbox
                    name="rememberMe"
                    label={this.props.lingua.read('lex.login.remember')}
                    checked={this.state.rememberMe}
                    onChange={this.handleCheck}
                    size={'sm'}
                    inline
                />
            </div>
            <ButtonPrimary type="submit" label={this.props.lingua.read('resetPassword.title')} onClick={this.buttonClicked} className="btn-lg">
                <LoadingOverlay loading={this.props.isWaiting}/>
            </ButtonPrimary>
        </div>);
    }

    render() {
        let passwordFieldSetup = this.state.resetPassword === true ? this.getResetPasswordContent() : this.getPasswordContent();
        let resetPasswordLink = (this.state.resetPassword === true || this.state.disableLogin === true) ?
            null : (<ButtonLink className="Link" label={this.props.lingua.read('lex.password.forgot.link')} onClick={this.resetPassword}/>);
        return (
            <div className="LogInComponent text-center">
                <form onSubmit={this.handleSubmit}>
                {!this.props.multiUserEnabled && <a onClick={this.editEmail} className="edit-email" href="">{this.props.lingua.read('lex.email.edit')}</a>}
                    <div className="EmailField">
                        <FormInput
                            id="lex-emailAddress"
                            name = "emailAddress"
                            className="email-address"
                            label = {this.props.lingua.read('form.placeholder.emailAddress')}
                            value = {this.state.emailAddress}
                            onChange = {this.handleChange}
                            type= "email"
                            autoComplete = "on"
                            disabled
                        />
                    </div>
                    {passwordFieldSetup}
                </form>
                {resetPasswordLink}
            </div>
        );
    }
}

export default LogInComponent;
